import { render } from "./TextEditInput.vue?vue&type=template&id=75f00d4c"
import script from "./TextEditInput.vue?vue&type=script&lang=js"
export * from "./TextEditInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp1\\htdocs\\HelpDesk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__